

import React, { useContext, useState, useEffect } from "react";
import AddItemForm from "./AddItemForm";
import BulkAddForm from "./BulkAddForm";
import Card from "../UI/Card";
import parse from "html-react-parser";
import AppContext from "../../store/app-context";
import { ChevronDown } from "react-feather";
import { useLocation } from "react-router-dom";

import styles from "./QuickAddNewBrand.module.css";

const QuickAddNewBrand = (props) => {
  const appCtx = useContext(AppContext);
  const isQuoteLineEmpty = !props?.quote?.quoteLineEntityList || props.quote.quoteLineEntityList.length === 0;
  const [isOpen, setIsOpen] = useState(isQuoteLineEmpty);
  const location = useLocation();

  useEffect(() => {
    if (!isOpen) {
      setIsOpen(isQuoteLineEmpty);
    }
  }, [isQuoteLineEmpty]);

  const isQuoteLoaded = !!props.quote;
  useEffect(() => {
    if (location.pathname === "/" && isQuoteLoaded) {
      setIsOpen(isQuoteLineEmpty);
    }
  }, [location.pathname, isQuoteLoaded]);

  let label_quickAdd = 'Quick Add';
  let label_itemOrFile = 'Add one item using a catalog number, or upload a file to add many at once.';
  let label_primeHomePage = 'PrimePCR Home Page';
  let label_primeCannotAddErrMsg = 'Cannot be added directly to the cart. Please search for the product using the gene name';

  if(appCtx && appCtx.bioradResources){
    label_quickAdd = appCtx.bioradResources.Quick_Add ? appCtx.bioradResources.Quick_Add : 'Quick Add';
    label_itemOrFile = appCtx.bioradResources.Add_Item_Or_Upload_File ? appCtx.bioradResources.Add_Item_Or_Upload_File : 'Add one item using a catalog number, or upload a file to add many at once.';
    label_primeHomePage = appCtx.bioradResources.PrimePCR_Home_Page ? appCtx.bioradResources.PrimePCR_Home_Page : 'PrimePCR Home Page';
    label_primeCannotAddErrMsg = appCtx.bioradResources.PrimePCR_Cannot_Add ? appCtx.bioradResources.PrimePCR_Cannot_Add : 'Cannot be added directly to the cart. Please search for the product using the gene name';
  }

  const primeHomePageURL = appCtx.envProp.appServer
  + appCtx.lang.toLowerCase() +
  "-" +
  appCtx.country.toLowerCase() +
  '/product/primepcr-pcr-primers-assays-arrays?ID=M0HROA15';

  let errorMessage = props.errorMsg && props.errorMsg.length > 0 ? props.errorMsg : null;
  if(errorMessage && errorMessage.indexOf('::') !== -1){
    const msgArray = errorMessage.split('::');
    if(msgArray && msgArray.length>1){
      if(msgArray[1] === 'oligo_UploadAddSku_Invalid'){
        errorMessage = msgArray[0] + ': ' + label_primeCannotAddErrMsg;
      }
    }
  }

  return (
    <Card className={styles.input}>
      <div className={styles.accordion}>
        <div className={styles.accordionHeader} onClick={() => setIsOpen((prev) => !prev)}>
          <div>
            <h2 className={styles.quickAddLabel}>{label_quickAdd}</h2>
            <p className={styles.quickAddSub}>{label_itemOrFile}</p>
          </div>
          <ChevronDown
            className={`${styles.chevron} ${isOpen ? styles.rotate : ""}`}
            size={20}
          />
        </div>
        {isOpen && (
          <Card className={styles.testing}>
            <AddItemForm onAddItem={props.onAddItem} quote={props.quote} isNewBrand={true}/>
            <BulkAddForm onAddItem={props.onAddItem} quote={props.quote} isNewBrand={true}/>
            {props.errorMsg &&
              props.errorMsg.indexOf("oligo_UploadAddSku_Invalid") === -1 &&
              errorMessage &&
              errorMessage.length > 0 && (
                <p className={styles.errormsg}>{parse(errorMessage)}</p>
              )}
            {props.errorMsg &&
              props.errorMsg.indexOf("oligo_UploadAddSku_Invalid") !== -1 &&
              errorMessage &&
              errorMessage.length > 0 && (
                <p className={styles.errormsg}>{parse(errorMessage)}&nbsp;<a href={primeHomePageURL}>{label_primeHomePage}</a></p>
              )}
          </Card>
        )}
      </div>        
    </Card>
  );
};

export default QuickAddNewBrand;

